import React from "react";
import { Company } from "../../../types";
import { ActionButton } from "../../shared/ActionButton";
import logo from "../../../assets/images/logo.png";

interface AppHeaderProps {
  onViewAppointments?: () => void;
  company?: Company | null;
}

export const AppHeader: React.FC<AppHeaderProps> = ({
  onViewAppointments,
  company,
}) => {
  return (
    <header className="relative bg-gray-800 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
      </div>

      <div className="relative container mx-auto px-6 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
          <div className="text-center lg:text-left">
            <div className="flex items-center justify-center lg:justify-start gap-3 mb-2">
              {company?.logo ? (
                <img
                  src={company.logo}
                  alt={`${company.name} logo`}
                  className="h-8 w-auto object-contain"
                />
              ) : (
                <img src={logo} alt="Logo" className="h-8 w-auto" />
              )}
              <h1 className="text-2xl lg:text-3xl font-bold text-white">
                {company?.name || "Agendamento Online"}
              </h1>
            </div>
            <p className="text-sm text-gray-300">
              📅{" "}
              {company?.category === "car"
                ? "Cuidar do seu veículo nunca foi tão fácil"
                : "Cuidar do seu visual nunca foi tão fácil"}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-end">
            {onViewAppointments && (
              <ActionButton
                onClick={onViewAppointments}
                variant="outline"
                size="sm"
                className="inline-flex items-center gap-2"
              >
                <span className="text-base">📅</span>
                <span>Meus Agendamentos</span>
              </ActionButton>
            )}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gray-700"></div>
    </header>
  );
};
